// extracted by mini-css-extract-plugin
export default {"main":"Main_main__FmIIu","previewMainContainer":"Main_previewMainContainer__j+6HQ","btnHelp":"Main_btnHelp__b-H4n"};